module.exports = __webpack_public_path__ + "media/images/share/whatsapp-90cfa5536f639168da0a8ca2c450f070.svg";